import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  resultsContainer: {
    maxWidth: 1440,
    margin: '0 auto',
    width: '100%',
  },
  gridContainerBrowse: {
    height: '100%',
    padding: '20px 16px 24px 16px',
    [Theme.breakpoints.up('md')]: {
      padding: '30px 40px 24px 40px',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: 24,
    },
  },
  resultsContainerBrowse: {
    display: 'inline',
    padding: '0',
    margin: '0',
    flexFlow: 'column wrap',
    fontFamily: Theme.typography.base.regular,
  },
  searchWrapperCardContentBrowse: {
    height: '100%',
    padding: '0',
    display: 'flex',
    flexGrow: '1',
    '&:last-child': {
      paddingBottom: '0',
    },
  },
  mobileClearFilterButtonBrowse: {
    marginTop: 30,

    [Theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  centeredBrowse: {
    textAlign: 'center',
  },
  mobileNoResultsBrowse: {
    [Theme.breakpoints.down('sm')]: {
      height: 'auto !important',
    },
  },
  customBanner: {
    marginBottom: 24,
    width: '100%',
  },
  resultsWrapperBrowse: {
    display: 'inline-flex',
    padding: '0',
    margin: '0',
    width: '100%',
    height: 'calc(100% - 200px)',
    [Theme.breakpoints.down('md')]: {
      height: 'calc(100% - 440px)',
    },
    [Theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 510px)',
    },
  },
  filterPanelHeaderBrowse: {
    zIndex: '9999',
    backgroundColor: Theme.palette.primary.main,

    '& .MuiTypography-root > p': {
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[1],
    },
  },
  filterSectionBrowse: {
    padding: 24,
    height: 'calc(100% + 32px)',
    background: '#FFF',
    borderBottomRightRadius: '0',
    [Theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  resultsFooterBrowse: {
    padding: '23px 20px',
    [Theme.breakpoints.up('md')]: {
      padding: '23px 50px',
    },
    [Theme.breakpoints.up('xl')]: {
      padding: '23px 70px 23px 60px',
    },
  },
  filtersPanelDrawerBrowse: {
    fontFamily: Theme.typography.base.regular,
    boxShadow: 'none',
    paddingTop: '60px',
    boxSizing: 'border-box',
    top: '60px',
    [Theme.breakpoints.down('md')]: {
      height: 'calc(100% - 60px)',
    },
    [Theme.breakpoints.up('xs')]: {
      padding: '30px 20px',
      width: '100%',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '30px 40px 30px 50px',
      width: '380px',
    },
  },
  newBrowseDepartingSection: {
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    [Theme.breakpoints.up('md')]: {
      marginBottom: '30px',
    },
    '& .title': {
      fontSize: Theme.typography.size[6],
      color: Theme.palette.primary.main,
      fontWeight: '600',
      letterSpacing: '0.8px',
      marginRight: '8px',
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[9],
      },
    },
    '& > span svg': {
      color: Theme.palette.primary.main,
      width: '16px',
      height: '16px',
      marginTop: '4px',
    },
  },
  wrapResultsSection: {
    '& > div > div > p': {
      [Theme.breakpoints.only('sm')]: {
        display: 'none',
      },
    },
  },
  wrapNewFormSection: {
    [Theme.breakpoints.up('lg')]: {
      marginLeft: '25px',
    },
  },
  progressLineContainer: {
    '& > div': {
      paddingLeft: '24px',
    },
  },
}));

export default useStyles;
